module.exports = __webpack_public_path__ + "img/sign_in_bg2.f3a73c3f.jpg";